module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201113_080.c9c76142.jpg";